/**
* @ngdoc directive
* @name Google Place Autocomplete
*
* @element input
*
* @description
  Use google geocode for address suggestions
  use choosed place to fill city, state, zip, street fields
*
* @scope
* @param {Object} contact - has params:
*   address
*   city
*   zip
*   stateName
*
* @example
  <div ng-init='contact = {}'>
    <input
      google-place-autocomplete
      contact='contact'
      name="address"
      type="text"
      class="form-control"
      ng-model="contact.address"
      maxlength="50"
      />
  </div>
*/

(function () {
  'use strict';

  app.directive('googlePlaceAutocomplete', directive);

  function directive() {
    return {
      restrict: 'A',
      require: 'ngModel',
      scope: {
        contact: '='
      },
      link: link
    };

    function link($scope, $element) {
      var autocomplete = new google.maps.places.Autocomplete(
          ($element[0]),
          { 'types': ['geocode'], 'componentRestrictions': {'country': 'us'} });

      autocomplete.addListener('place_changed', fillInAddress);

      function fillInAddress() {
        /*
          fixes an issue when user:
          1. writes address (12 Main Road)
          2. selects address from google maps dropdown, so:
          - google changes address in input to the selected one (12 Main Road, Houston, ...)
          - code below changes it to the format "house number + route" (12 Main Road)
          3. changes house number (10 Main Road)
          4. selects address from google maps dropdown, so:
          - google changes address in input to the selected one (10 Main Road, Houston, ...)
          - ISSUE: code below DOES NOT change it to the format "house number + route" (12 Main Road):
            - $scope.$apply() does not change value in input for some reason, however it changes $viewValue
            - $scope.$apply() works fine, when we set address as route

          we fix this issue by setting $scope.contact.address value to the selected from google value
        */
        $scope.contact.address = $element.context.value;
        $scope.$apply();

        var place = autocomplete.getPlace();

        var addressProps = {};
        if (!place.address_components) {
          addressProps.route = place.name;
        } else {
          place.address_components.forEach(function (component) {
            var type = component.types[0];
            addressProps[type] = component.long_name;
          });
        }

        $scope.contact.address = addressProps.route && toTitleCase(addressProps.route);
        if (addressProps.street_number) $scope.contact.address = addressProps.street_number + ' ' + $scope.contact.address;

        $scope.contact.city = addressProps.locality;
        $scope.contact.zip = addressProps.postal_code;

        if (addressProps.postal_code_suffix) $scope.contact.zip += '-' + addressProps.postal_code_suffix;

        $scope.contact.stateName = addressProps.administrative_area_level_1;

        $scope.$apply();
      }

      function toTitleCase(str) {
        return str.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
      }
    }
  }
}());



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/googlePlaceAutocomplete.js